// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper--18iRl","Chat":"Chat--2jyL9","Collapse":"Collapse--19OPM","ChatUnselected":"ChatUnselected--163nY","Tour":"Tour--2cPLO"};